import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

import { ExclamationMarkSvg } from '../../../../assets/icons';
import GoogleDriveSvg from '../../../../assets/icons/GoogleDriveSvg';
import theme from '../../../../assets/theme';

/**
 * The Google Drive option's icon, wherever Drive is offered: the Drive mark
 * once the integration has loaded, an orange spinner while it is still
 * loading, and an exclamation mark when it failed to load.
 *
 * One component so the "Add Materials" menu, the lesson editor's attachments
 * tab and the passage flow's Drive card all say the same thing about Drive's
 * state — change it here and every surface follows.
 */
export function GoogleDriveStatusIcon({
  isReady,
  isError,
  size = 20,
  spinnerStyle,
}: {
  isReady?: boolean;
  isError?: boolean;
  size?: number;
  /** For a caller that spaces the spinner differently from the icons. */
  spinnerStyle?: React.CSSProperties;
}) {
  if (isError) return <ExclamationMarkSvg width={size} height={size} />;
  if (!isReady) {
    return (
      <Spin
        indicator={
          <LoadingOutlined
            style={{ fontSize: size, color: theme.colors.orange, ...spinnerStyle }}
            spin
          />
        }
      />
    );
  }
  return <GoogleDriveSvg size={size} style={{ display: 'block' }} />;
}
